import ApplicationRouter from './Routing/ApplicationRouter';
import { useFetchVersionQuery } from '../Api/applicationApi';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from './store';
import { queueAnnouncement } from './Components/Announcements/AnnouncementSlice';
import { AppSettings } from './Configuration/types';
import { AnnouncementActionTypes } from './Components/Announcements/types';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';

/**
 * Entry point of the rendering Application.
 */
export default function Application() {
	const appDispatch = useAppDispatch();
	const versionInterval = useAppSelector((state) => (state.appSettings as AppSettings).versionFetchIntervalSeconds);
	const [killPolling, setKillPolling] = useState<boolean>(false);
	const {
		data: versionResponse,
		isError,
		error
	} = useFetchVersionQuery(undefined, {
		pollingInterval: !killPolling ? versionInterval * 1000 : undefined
	});
	const appInsights = useAppInsightsContext();

	useEffect(() => {
		if (versionResponse?.version && versionResponse.version !== NPM_PACKAGE_VERSION) {
			setKillPolling(true);
			appDispatch(
				queueAnnouncement({
					title: `Version ${versionResponse.version} is available!`,
					severity: 'info',
					action: AnnouncementActionTypes.Update,
					filled: true
				})
			);
		}
	}, [versionResponse, appDispatch]);

	useEffect(() => {
		const errorMsg = 'Version.json file could not be retrieved.';
		if (isError) {
			appInsights.trackException({
				exception: {
					name: 'Exception - Not Found',
					message: errorMsg
				}
			});
		}
	}, [isError, error, appInsights]);

	return <ApplicationRouter />;
}
